import { css } from '@/styled-system/css';

export const content = css({ width: '100%', minWidth: 0 });
export const row = css({ display: 'flex', alignItems: 'center', gap: 'tighter' });
export const line = css({ height: '{spacing.default}', width: '100%' });
export const shortLine = css({ height: '{spacing.default}', width: '40%' });
export const title = css({ height: '{spacing.loose}', width: '60%' });
export const rating = css({ height: 'calc(3 * {spacing.default})', width: '25%' });
export const tabs = css({ height: '1000', width: '100%' });
export const icon = css({ width: '800', height: '800', flexShrink: 0 });
export const stars = css({ height: '400', width: 'calc(5 * {spacing.default} + 4 * {spacing.micro.default})' });
export const text = css({ backgroundColor: 'bg.softer', borderRadius: 'sm', boxDecorationBreak: 'clone' });
export const invisible = css({ visibility: 'hidden' });
export const categoryHeading = css({ fontSize: 'heading-xs', lineHeight: 'heading-xs', fontWeight: 'bold' });
export const search = css({ width: '2000', height: '600', flexShrink: 0 });
export const card = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  padding: 'default',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.muted',
  borderRadius: 'md',
});
export const google = css({ minHeight: 'calc(28 * {spacing.default})' });
export const googleContent = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  padding: 'default',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.muted',
  borderRadius: 'md',
  minHeight: 'calc(28 * {spacing.default})',
});
export const visuallyHidden = css({ srOnly: true });
export const pagination = css({ display: 'flex', justifyContent: 'center', lg: { display: 'none' } });
export const seeAll = css({
  lg: { '&[data-count="1"], &[data-count="2"]': { display: 'none' } },
  xl: { '&[data-count="3"], &[data-count="4"]': { display: 'none' } },
});
export const webCards = css({
  display: 'flex',
  gap: 'tighter',
  overflow: 'hidden',
  alignItems: 'start',
  '& > div': { flexShrink: 0, flexBasis: 'calc(100% - {spacing.loose})', height: 'auto' },
  lg: { display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', '& > div:nth-child(n + 3)': { display: 'none' } },
  xl: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    '& > div:nth-child(3), & > div:nth-child(4)': { display: 'flex' },
  },
});
